import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["state"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useContext, useMemo } from 'react';
import { useEvent } from 'ariakit-utils/hooks';
import { createHook, createComponent, createElement } from 'ariakit-utils/system';
import { D as DialogContext } from '../dialog-context-f963dd70.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useButton } from '../button/button.js';
/**
 * A component hook that returns props that can be passed to `Role` or any other
 * Ariakit component to render a button that hides a dialog.
 * @see https://ariakit.org/components/dialog
 * @example
 * ```jsx
 * const state = useDialogState();
 * const props = useDialogDismiss({ state });
 * <Dialog state={state}>
 *   <Role {...props} />
 * </Dialog>
 * ```
 */

var useDialogDismiss = createHook(function (_ref) {
  var state = _ref.state,
      props = _objectWithoutProperties(_ref, _excluded);

  var context = useContext(DialogContext);
  state = state || context;
  var onClickProp = props.onClick;
  var onClick = useEvent(function (event) {
    var _state;

    onClickProp == null ? void 0 : onClickProp(event);
    if (event.defaultPrevented) return;
    (_state = state) == null ? void 0 : _state.hide();
  });
  var children = useMemo(function () {
    return /*#__PURE__*/jsxs("svg", {
      "aria-label": "Dismiss popup",
      display: "block",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5pt",
      viewBox: "0 0 16 16",
      height: "1em",
      width: "1em",
      children: [/*#__PURE__*/jsx("line", {
        x1: "4",
        y1: "4",
        x2: "12",
        y2: "12"
      }), /*#__PURE__*/jsx("line", {
        x1: "4",
        y1: "12",
        x2: "12",
        y2: "4"
      })]
    });
  }, []);
  props = _objectSpread(_objectSpread({
    "data-dialog-dismiss": "",
    children: children
  }, props), {}, {
    onClick: onClick
  });
  props = useButton(props);
  return props;
});
/**
 * A component that renders a button that hides a dialog.
 * @see https://ariakit.org/components/dialog
 * @example
 * ```jsx
 * const dialog = useDialogState();
 * <Dialog state={dialog}>
 *   <DialogDismiss />
 * </Dialog>
 * ```
 */

var DialogDismiss = createComponent(function (props) {
  var htmlProps = useDialogDismiss(props);
  return createElement("button", htmlProps);
});
export { DialogDismiss, useDialogDismiss };